import { render } from "./SummaryOrdersSent.vue?vue&type=template&id=232e8e8b&scoped=true"
import script from "./SummaryOrdersSent.vue?vue&type=script&lang=js"
export * from "./SummaryOrdersSent.vue?vue&type=script&lang=js"

import "./SummaryOrdersSent.vue?vue&type=style&index=0&id=232e8e8b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232e8e8b"]])

export default __exports__